import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { Flex, Typography, Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getClientsList, postAgreement } from "src/store/Slices/ClientsSlice";

const AddAgreeModal = ({ visible, setVisible, clientInfo, addEditPayload }) => {
  // HELPERS
  const dispatch = useDispatch();
  // STATE
  const [fileList, setFileList] = useState([]);

  console.log("tutututu", clientInfo);
  // FUNCTIONS
  const onClickAddAgreement = () => {
    const formData = new FormData();
    formData.append("userId", clientInfo.id);
    fileList.forEach((file) => {
      formData.append("photo", file);
    });
    dispatch(postAgreement(formData)).then(() => {
      dispatch(getClientsList(addEditPayload));
      setVisible(false);
    });
  };

  const handleChange = (info) => {
    if (info.fileList.length === 0) {
      setFileList([]);
    } else {
      let newFileList = [...fileList];
      newFileList = newFileList.slice(-1);

      setFileList(newFileList);
    }
  };

  const uploadProps = {
    accept: ".png,.jpg,.jpeg,.pdf,.doc,.docx",
    onRemove: () => {
      setFileList([]);
    },
    onChange: handleChange,
    beforeUpload: (file) => {
      const isTooLarge = file.size / 1024 / 1024 > 10;
      if (isTooLarge) {
        openNotification({
          type: "error",
          message: "Размер файла должен быть меньше десяти мегабайт",
        });
        return false;
      }
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  useEffect(() => {}, [visible]);

  return (
    <>
      <CModal
        alignment="center"
        visible={visible}
        onClose={() => setVisible(false)}
        aria-labelledby="VerticallyCenteredExample"
      >
        <CModalHeader>
          <CModalTitle id="VerticallyCenteredExample">
            Добавить соглашение
          </CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Flex vertical gap={16} style={{ marginTop: "20px" }}>
            <>
              <div>
                <Typography.Title level={5}>
                  Соглашение (размер меньше 10 МБ)
                </Typography.Title>
                <Upload {...uploadProps}>
                  <Button icon={<UploadOutlined />}>Выберите файл</Button>
                </Upload>
              </div>
            </>
          </Flex>
        </CModalBody>
        <CModalFooter>
          <CButton
            color="secondary text-light"
            onClick={() => {
              setVisible(false);
            }}
          >
            Закрыть
          </CButton>
          <CButton color="primary text-light" onClick={onClickAddAgreement}>
            Сохранить
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  );
};

export default AddAgreeModal;
